// extracted by mini-css-extract-plugin
export default {"supportTickets":"styles_supportTickets__jmW23","loading":"styles_loading__RITn7"};